<p>
  <span nz-icon nzType="warning"></span> Please generate the query first before applying the filter.
</p>
<form nz-form [formGroup]="queryForm" (ngSubmit)="onSubmit()">
  <div formArrayName="groups">
    <div
      *ngFor="let group of groups.controls; let i = index"
      [formGroupName]="i"
      class="group-container"
    >
      <div class="group-header">
        <nz-select
          class="group-operator"
          formControlName="logicalOperator"
          [nzDisabled]="i === 0"
          nzSize="small"
        >
          <nz-option nzLabel="AND" nzValue="AND"></nz-option>
          <nz-option nzLabel="OR" nzValue="OR"></nz-option>
        </nz-select>
        <button
          nz-button
          nzType="text"
          type="button"
          nzDanger
          nzSize="small"
          (click)="removeGroup(i)"
          *ngIf="groups.controls.length > 1"
        >
          <span nz-icon nzType="close"></span>
        </button>
      </div>

      <div class="conditions-container">
        <div formArrayName="conditions">
          <div
            *ngFor="let condition of getGroupConditions(i).controls; let j = index"
            [formGroupName]="j"
            class="condition-row"
          >
            <div class="condition-fields">
              <nz-form-item style="gap: 1rem" nz-row>
                <nz-form-control nzSpan="8">
                  <nz-select formControlName="field" placeholder="Field" nzSize="small">
                    <nz-option
                      *ngFor="let field of fields"
                      [nzLabel]="field.label"
                      [nzValue]="field.value"
                    ></nz-option>
                  </nz-select>
                </nz-form-control>

                <nz-form-control nzSpan="6">
                  <nz-select
                    formControlName="operator"
                    placeholder="Operator"
                    nzSize="small"
                    (ngModelChange)="onOperatorChange(i, j)"
                  >
                    <nz-option-group
                      *ngFor="let group of operatorGroups"
                      [nzLabel]="group.category"
                    >
                      <nz-option
                        *ngFor="let op of group.operators"
                        [nzLabel]="op.label"
                        [nzValue]="op.value"
                      >
                      </nz-option>
                    </nz-option-group>
                  </nz-select>
                </nz-form-control>

                <nz-form-control nzSpan="8">
                  <ng-container [ngSwitch]="condition.value?.operator">
                    <!-- Between Input -->
                    <div *ngSwitchCase="'BETWEEN'" class="between-inputs">
                      <input
                        nz-input
                        placeholder="Start"
                        formControlName="valueStart"
                        nzSize="small"
                      />
                      <div class="and-text">AND</div>
                      <input nz-input placeholder="End" formControlName="valueEnd" nzSize="small" />
                    </div>
                    <div *ngSwitchCase="'NOT BETWEEN'" class="between-inputs">
                      <input
                        nz-input
                        placeholder="Start"
                        formControlName="valueStart"
                        nzSize="small"
                      />
                      <div class="and-text">AND</div>
                      <input nz-input placeholder="End" formControlName="valueEnd" nzSize="small" />
                    </div>

                    <!-- In List Input -->
                    <nz-select
                      *ngSwitchCase="'IN'"
                      nzMode="tags"
                      nzPlaceHolder="Enter values"
                      [formControl]="getValueList(i, j)"
                      nzSize="small"
                    >
                    </nz-select>
                    <nz-select
                      *ngSwitchCase="'NOT IN'"
                      nzMode="tags"
                      nzPlaceHolder="Enter values"
                      [formControl]="getValueList(i, j)"
                      nzSize="small"
                    >
                    </nz-select>

                    <!-- Default Input -->
                    <input
                      *ngSwitchDefault
                      nz-input
                      [placeholder]="getValuePlaceholder(condition.value.operator)"
                      [disabled]="isValueDisabled(condition.value.operator)"
                      formControlName="value"
                      nzSize="small"
                    />
                  </ng-container>

                  <!-- Hint Text -->
                  <small class="value-hint" *ngIf="condition.value.operator">
                    {{ getValueHint(condition.value.operator) }}
                  </small>
                </nz-form-control>

                <nz-form-control nzSpan="2">
                  <button
                    nz-button
                    nzType="text"
                    nzDanger
                    nzSize="small"
                    (click)="removeCondition(i, j)"
                    *ngIf="getGroupConditions(i).controls.length > 1"
                    type="button"
                  >
                    <span nz-icon nzType="delete"></span>
                  </button>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="condition-operator" *ngIf="j < getGroupConditions(i).controls.length - 1">
              <nz-select
                class="and-or-select"
                [formControl]="getLogicalOperatorControl(i, j + 1)"
                nzSize="small"
              >
                <nz-option nzLabel="AND" nzValue="AND"></nz-option>
                <nz-option nzLabel="OR" nzValue="OR"></nz-option>
              </nz-select>
            </div>
          </div>
        </div>
      </div>

      <div class="group-footer">
        <button
          nz-button
          nzType="dashed"
          nzSize="small"
          (click)="addConditionToGroup(i)"
          type="button"
        >
          <span nz-icon nzType="plus"></span> Add Condition
        </button>
      </div>
    </div>
  </div>

  <div class="actions-container">
    <button type="button" nz-button nzType="dashed" (click)="addGroup()">
      <span nz-icon nzType="plus"></span> Add Group
    </button>
    <button nz-button nzType="primary">Generate Query</button>
  </div>

  <div class="output-container">
    <div class="output-section">
      <h4>SQL Query:</h4>
      <pre class="sql-output">{{ generatedSQL }}</pre>
    </div>
  </div>
</form>
